import React, { useEffect } from 'react'

import { PageMenu } from '../../../../components'
import { IconOrdemColetaBlue } from '../../../../assets/imgs'
import { menuItemsAllowed } from '../../../../services/permission/menus'
import NotAllowedModule from '../../../../components/NotAllowedModule/NotAllowedModule'
import { TpPermissions, verifyTpPermission } from '../../../../services/permission/menus'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

function OrdemColetaMenu({ selectedTp }) {
  const [allowed, setAllowed] = React.useState(true)

  useEffect(() => {
    const allowed = verifyTpPermission(TpPermissions.ORDEM_COLETA, selectedTp)
    setAllowed(allowed)
  }, [selectedTp])

  const menuItems = menuItemsAllowed([
    {
      id: 5,
      content: { menu: '5.1 - Ordens de Coleta', path: '/main/ordemcoleta/ordens-coleta' },
    },
    {
      id: 6,
      content: {
        menu: '5.2 - Aprovação Ordem de Coleta',
        path: '/main/ordemcoleta/aprovacao-ordem-coleta',
      },
    },
    {
      id: 7,
      content: { menu: '5.3 - Local de Descarga', path: '/main/ordemcoleta/local-descarga' },
    },
    {
      id: 13,
      content: {
        menu: '5.4 - Análise das Ocorrências',
        path: '/main/ordemcoleta/analise-das-ocorrencias',
      },
    },
    {
      id: 25,
      content: {
        menu: '5.5 - Ocorrências Por Colaboradores',
        path: '/main/ordemcoleta/ocorrencias-por-colaboradores',
      },
    },
  ])
  return (
    <>
      <PageMenu menuItems={allowed ? menuItems : []}>
        <img src={IconOrdemColetaBlue} alt="Icon Ordem de Coleta" />
        <span style={{ display: 'inline-block', marginLeft: 10 }}>5. Ordem de Coleta</span>
      </PageMenu>
      {!allowed && <NotAllowedModule />}
    </>
  )
}

const mapStateToProp = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProp)(withRouter(OrdemColetaMenu))
